import { z } from "zod";

export const viewInspectorSchema = z.object({
  name: z.string().min(1, "View name is required"),
  viewDescription: z.string().optional(),
  folderId: z.number().nullable(),
  iconId: z.number().nullable(),
  color: z.string().nullable().optional(),
  isShareToHQ: z.boolean(),
  isShareToWorkforce: z.boolean(),
  isShareToPublic: z.boolean(),
});
